export const faqItems = [
  {
    question: '今日看料每天什么时候更新内容？',
    answer: '我们每日凌晨 6:00 准时更新精选内容，涵盖生活妙招、热门话题、美食食谱、居家技巧等多个板块。周末和节假日照常更新，让美好生活从每一个清晨开始。',
  },
  {
    question: '今日看料的内容来源是什么？',
    answer: '我们的编辑团队每天从海量生活资讯中精心筛选，结合读者投稿和专家建议，确保每一条内容都经过核实与优化。我们注重原创性与实用性，力求为读者提供真正有价值的生活参考。',
  },
  {
    question: '如何在今日看料找到我感兴趣的话题？',
    answer: '您可以通过首页的主题索引区快速定位感兴趣的话题板块，也可以使用页面顶部的导航直达核心模块。热门话题和排行榜区域会展示当前最受关注的内容，帮助您轻松发现新鲜料。',
  },
  {
    question: '今日看料支持投稿吗？',
    answer: '非常欢迎！我们长期向读者开放投稿通道，无论是生活小妙招、美食分享还是居家创意，都可以通过联系我们板块提交。编辑团队会在 3 个工作日内审核并回复，优秀稿件将获得首页推荐机会。',
  },
  {
    question: '今日看料的内容是否免费？',
    answer: '是的，今日看料所有内容完全免费。我们致力于让更多人享受高品质的生活资讯服务，不设置付费墙或会员门槛。您可以在任何设备上自由浏览全部内容。',
  },
  {
    question: '发现内容有误怎么办？',
    answer: '如果您发现任何内容存在事实性错误或不妥之处，请通过联系我们板块向我们反馈。我们非常重视读者意见，会在核实后第一时间修正并致谢。',
  },
];

export const featuresItems = [
  {
    icon: 'ri-sun-line',
    title: '每日新鲜精选',
    description: '每天清晨准时更新，从海量信息中筛选最值得关注的精选内容，确保您不会错过任何美好生活的灵感。',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: '实用生活妙招',
    description: '涵盖家居清洁、美食烹饪、收纳整理等实用技巧，每条妙招都经过实测验证，真正解决日常生活中的小烦恼。',
  },
  {
    icon: 'ri-fire-line',
    title: '热门话题追踪',
    description: '紧跟社会热点和生活趋势，深度解读现象背后的思考，让您在茶余饭后有料可聊、有话可说。',
  },
  {
    icon: 'ri-team-line',
    title: '读者共创社区',
    description: '开放投稿与评论互动，每一位读者都是看料的贡献者。您的分享可能成为下一个引爆话题的精彩内容。',
  },
];

export const rankingItems = [
  { rank: 1, title: '夏季冰箱收纳终极指南：空间利用率翻倍的 8 个技巧', views: '12.8万', tag: '居家妙招', trend: 'up' },
  { rank: 2, title: '三伏天养生全攻略：饮食调理搭配穴位按摩一篇搞定', views: '9.6万', tag: '健康养生', trend: 'up' },
  { rank: 3, title: '月薪 5000 也能精致生活：年轻人省钱不降质的消费哲学', views: '8.3万', tag: '生活态度', trend: 'new' },
  { rank: 4, title: '厨房小白必备：10 道零失败家常菜详细教程合集', views: '7.1万', tag: '美食烹饪', trend: 'up' },
  { rank: 5, title: '租房改造灵感：2000 元预算打造温馨小窝全记录', views: '6.5万', tag: '居家改造', trend: 'stable' },
];

export const topicsItems = [
  { name: '居家收纳', count: '2.8万', icon: 'ri-home-4-line' },
  { name: '美食烹饪', count: '3.1万', icon: 'ri-restaurant-line' },
  { name: '健康养生', count: '2.5万', icon: 'ri-heart-pulse-line' },
  { name: '省钱攻略', count: '1.9万', icon: 'ri-money-cny-circle-line' },
  { name: '旅行出游', count: '1.7万', icon: 'ri-flight-takeoff-line' },
  { name: '亲子育儿', count: '2.1万', icon: 'ri-parent-line' },
  { name: '美容护肤', count: '1.6万', icon: 'ri-magic-line' },
  { name: '数码好物', count: '1.4万', icon: 'ri-smartphone-line' },
  { name: '宠物日常', count: '1.2万', icon: 'ri-bear-smile-line' },
];

export const carouselItems = [
  {
    title: '2026 夏日生活新风尚：极简主义的 5 个实践法则',
    summary: '从断舍离到精准消费，极简不只是一种生活方式，更是一种内心秩序的建立。本期专题带你用最简单的方式，过上最充实的生活。',
    tag: '专题策划',
    image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20interior%20living%20room%20with%20natural%20wood%20furniture%2C%20soft%20sunlight%20streaming%20through%20large%20windows%2C%20clean%20aesthetic%20with%20green%20plants%2C%20cozy%20atmosphere%2C%20editorial%20photography%20style%20with%20warm%20neutral%20tones%2C%20high%20quality%20interior%20design%20magazine%20look%2C%20peaceful%20and%20inviting%20ambiance&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '从厨房到餐桌：30 分钟搞定一桌宴客菜的秘密',
    summary: '谁说宴客一定要忙一整天？掌握备菜逻辑和时间管理技巧，半小时就能端出令人惊艳的四菜一汤，既体面又不失仪式感。',
    tag: '美食特辑',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20home%20cooked%20meal%20on%20wooden%20dining%20table%20with%20multiple%20colorful%20dishes%2C%20warm%20lighting%20from%20above%2C%20fresh%20ingredients%20visible%2C%20rustic%20ceramic%20plates%2C%20cooking%20scene%20with%20steam%20rising%2C%20food%20photography%20style%20with%20rich%20warm%20colors%2C%20inviting%20and%20appetizing%20atmosphere&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '都市人的周末逃离计划：周边 2 小时自驾目的地精选',
    summary: '不请假、不坐飞机，周末两天就能完成的短途旅行。我们实地探访了 8 个藏在城市周边的宝藏目的地，每一个都值得说走就走。',
    tag: '出行指南',
    image: 'https://readdy.ai/api/search-image?query=Scenic%20countryside%20road%20winding%20through%20green%20hills%20under%20bright%20blue%20sky%20with%20fluffy%20white%20clouds%2C%20small%20village%20in%20distance%2C%20summer%20vibes%2C%20road%20trip%20aesthetic%2C%20warm%20sunlight%20illuminating%20the%20landscape%2C%20travel%20magazine%20photography%20style%2C%20free%20and%20adventurous%20mood&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '换季衣柜大作战：胶囊衣橱打造全年穿搭系统',
    summary: '用 30 件单品搭出 100+ 套造型不是梦。我们邀请专业形象顾问，手把手教你建立属于自己的胶囊衣橱，告别每天早上面对满柜衣服却不知道穿什么的烦恼。',
    tag: '穿搭美学',
    image: 'https://readdy.ai/api/search-image?query=Organized%20walk%20in%20closet%20with%20neatly%20arranged%20clothing%20in%20earth%20tones%20and%20neutral%20colors%2C%20warm%20wooden%20shelves%20and%20hangers%2C%20soft%20natural%20lighting%20from%20window%2C%20minimalist%20aesthetic%2C%20fashion%20organization%20editorial%20style%2C%20clean%20and%20sophisticated%20atmosphere&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    title: '在家也能做的 15 分钟高效燃脂训练：零器械全攻略',
    summary: '不需要健身房会员，不需要专业器械，只需要一张瑜伽垫和一颗想动起来的心。这套编排经过运动科学验证，高效且安全，适合各年龄段。',
    tag: '运动健康',
    image: 'https://readdy.ai/api/search-image?query=Bright%20airy%20living%20room%20with%20yoga%20mat%20on%20wooden%20floor%2C%20morning%20sunlight%20streaming%20through%20windows%2C%20green%20plants%20in%20corner%2C%20minimalist%20home%20gym%20setup%2C%20warm%20and%20energetic%20atmosphere%2C%20wellness%20lifestyle%20photography%20style%2C%20healthy%20living%20aesthetic&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
];

export const contactInfo = {
  title: '联系我们',
  subtitle: '投稿、合作、反馈，我们期待听到您的声音',
  description: '无论您是想分享生活中的妙招心得，还是对我们有任何建议与意见，都欢迎通过以下方式与我们取得联系。编辑团队工作日 9:00–18:00 在线，期待与您交流。',
  email: 'hello@jinrikankao.com',
  responseTime: '投稿回复：3个工作日内',
};

export const commentsItems = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20woman%20in%20her%2030s%2C%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20cream%20background%2C%20casual%20professional%20look%2C%20friendly%20and%20approachable%20expression&width=80&height=80&seq=avatar-user-01&orientation=squarish',
    name: '小鹿斑比',
    content: '冰箱收纳那篇真的太实用了！按照教程整理完，冰箱瞬间空出一半空间，老公都惊呆了。现在每天打开冰箱心情特别好～',
    time: '2 小时前',
    likes: 326,
    tag: '居家妙招',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20man%20in%20his%2020s%2C%20gentle%20smile%2C%20soft%20studio%20lighting%2C%20clean%20light%20gray%20background%2C%20smart%20casual%20style%2C%20confident%20and%20friendly%20expression&width=80&height=80&seq=avatar-user-02&orientation=squarish',
    name: '阿杰',
    content: '坚持看今日看料快半年了，每天早上蹲坑时间必刷。从美食到收纳再到省钱攻略，感觉生活质量真的有在提升，给编辑部加鸡腿！',
    time: '5 小时前',
    likes: 198,
    tag: '日常推荐',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Chinese%20woman%20in%20her%2040s%2C%20warm%20confident%20smile%2C%20soft%20window%20light%2C%20warm%20cream%20background%2C%20elegant%20casual%20attire%2C%20motherly%20and%20wise%20expression&width=80&height=80&seq=avatar-user-03&orientation=squarish',
    name: '温暖阳光',
    content: '作为一个二胎妈妈，亲子育儿板块简直是我的救星。那篇关于暑假安排的文章转发到家长群，好多妈妈都在问哪里看到的哈哈。',
    time: '昨天 21:30',
    likes: 452,
    tag: '亲子育儿',
  },
];

export const cardsItems = [
  {
    title: '梅雨季节防潮全攻略：从墙面到衣物一篇文章说透',
    summary: '回南天、梅雨季，潮湿带来的烦恼数不胜数。我们整理了从物理除湿到化学防霉的完整方案，覆盖居家防潮的每一个角落。',
    tag: '居家妙招',
    time: '3 小时前',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20bedroom%20interior%20with%20dehumidifier%20and%20moisture%20absorbing%20products%20on%20nightstand%2C%20warm%20lighting%20through%20curtains%2C%20wooden%20furniture%2C%20clean%20and%20dry%20atmosphere%2C%20home%20care%20lifestyle%20photography%2C%20soft%20natural%20morning%20light&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    title: '上班族一周备菜法：周日花 2 小时搞定 5 天工作日三餐',
    summary: '告别每天下班后还要纠结吃什么、做什么的疲惫状态。这套备菜方法论已经帮助超过 10 万上班族实现了高效饮食管理。',
    tag: '美食烹饪',
    time: '昨天 15:20',
    image: 'https://readdy.ai/api/search-image?query=Meal%20prep%20containers%20neatly%20arranged%20on%20kitchen%20counter%2C%20colorful%20fresh%20vegetables%20and%20ingredients%20in%20glass%20containers%2C%20modern%20bright%20kitchen%2C%20organized%20and%20efficient%20look%2C%20food%20preparation%20scene%2C%20warm%20natural%20lighting&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    title: '养宠新手指南：第一次接猫回家需要准备什么',
    summary: '从猫砂盆的选择到疫苗时间表，从猫粮配比到社会化训练，这份超详细的新手养猫清单覆盖了接猫前中后三个月所有注意事项。',
    tag: '宠物日常',
    time: '2 天前',
    image: 'https://readdy.ai/api/search-image?query=Cute%20fluffy%20kitten%20sitting%20on%20cozy%20blanket%20near%20window%2C%20cat%20toys%20and%20scratching%20post%20in%20background%2C%20warm%20sunlight%20illuminating%20the%20scene%2C%20homey%20atmosphere%2C%20pet%20lifestyle%20photography%2C%20heartwarming%20and%20adorable&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    title: '护肤成分党入门：看懂成分表不再被营销套路',
    summary: '烟酰胺、视黄醇、玻尿酸……这些听起来高大上的成分到底有什么用？我们邀请了皮肤科医生，用最通俗的语言拆解常见护肤成分。',
    tag: '美容护肤',
    time: '3 天前',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20skincare%20products%20arranged%20on%20marble%20vanity%20table%2C%20soft%20natural%20light%20from%20window%2C%20fresh%20flowers%20beside%20products%2C%20minimalist%20beauty%20aesthetic%2C%20clean%20and%20fresh%20atmosphere%2C%20beauty%20editorial%20photography%20style&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    title: '智能家居入门：1000 元预算改造出租屋全记录',
    summary: '不用换房也不用大动干戈，几件性价比超高的智能设备就能让出租屋的生活品质大幅提升。从智能灯到自动窗帘，改造实录全分享。',
    tag: '数码好物',
    time: '4 天前',
    image: 'https://readdy.ai/api/search-image?query=Modern%20smart%20home%20devices%20on%20wooden%20desk%2C%20smart%20speaker%20and%20smart%20bulbs%20with%20warm%20glow%2C%20cozy%20bedroom%20setting%2C%20evening%20ambiance%2C%20tech%20lifestyle%20photography%2C%20comfortable%20and%20modern%20living%20space&width=600&height=400&seq=card-05&orientation=landscape',
  },
];

export const updatesItems = [
  { time: '07:30', date: '7月30日', title: '本周热门回顾：三伏天养生话题阅读量突破 20 万', tag: '数据快报' },
  { time: '06:00', date: '7月30日', title: '今日更新：6 篇新鲜精选内容已上线，涵盖美食、收纳、旅行三大板块', tag: '每日更新' },
  { time: '18:30', date: '7月29日', title: '读者投稿精选：一位退休教师的阳台花园打造心得感动数万人', tag: '读者来稿' },
  { time: '12:00', date: '7月29日', title: '编辑部公告：8 月特辑"暑期亲子时光"系列策划启动，欢迎投稿', tag: '站点公告' },
  { time: '08:00', date: '7月28日', title: '合作伙伴动态：联合知名家居品牌推出"理想家"读者互动专题', tag: '合作动态' },
  { time: '15:00', date: '7月27日', title: '内容升级：即日起新增"周末去哪儿"城市周边游专栏', tag: '栏目上新' },
  { time: '10:00', date: '7月26日', title: '服务器升级完成：页面加载速度提升 40%，浏览体验全面优化', tag: '站点维护' },
  { time: '06:00', date: '7月25日', title: '今日精选：冰箱收纳终极指南蝉联本周阅读榜首', tag: '每日更新' },
  { time: '20:00', date: '7月24日', title: '读者互动：本月投稿数量创历史新高，感谢每一位分享生活的你', tag: '读者来稿' },
];

export const appInfo = {
  title: '随时随地，看料不停',
  subtitle: '今日看料移动体验',
  description: '在手机和平板上获得更流畅的浏览体验。我们针对移动端做了深度优化，无论是在通勤路上还是睡前放松，都能轻松翻阅每日精选内容。收藏功能、离线阅读、推送提醒——让美好生活触手可及。',
  features: ['收藏同步', '离线阅读', '推送提醒', '夜间模式'],
};

export const aboutInfo = {
  title: '关于今日看料',
  content: '今日看料诞生于 2024 年初，由一群热爱生活、乐于分享的编辑和创作者共同发起。我们相信，美好生活从来不是遥不可及的理想，而是藏在每一天的琐碎日常里——一道用心的家常菜、一个巧妙的收纳技巧、一次说走就走的短途旅行。我们每天从海量生活资讯中精选最有价值的内容，经过核实、优化和编排，呈现给每一位追求品质生活的读者。今日看料不只是一个内容平台，更是一个生活灵感的聚集地。我们期待与你一起，从今天开始，把每一天都过成美好的样子。',
  stats: [
    { value: '1860+', label: '原创精选' },
    { value: '50万+', label: '月活读者' },
    { value: '98.5%', label: '好评率' },
    { value: '365天', label: '全年无休' },
  ],
};

export const indexItems = [
  {
    title: '居家妙招',
    description: '收纳整理、清洁技巧、家居改造，让家变得更舒适',
    count: 326,
    icon: 'ri-home-4-line',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20Scandinavian%20style%20living%20room%20interior%20with%20organized%20shelves%2C%20warm%20textiles%2C%20indoor%20plants%2C%20natural%20light%20from%20large%20window%2C%20clean%20and%20inviting%20home%20atmosphere%2C%20minimalist%20aesthetic%2C%20lifestyle%20photography&width=400&height=300&seq=index-01&orientation=landscape',
  },
  {
    title: '美食烹饪',
    description: '家常菜谱、烘焙甜品、厨房技巧，人人都是大厨',
    count: 412,
    icon: 'ri-restaurant-line',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20home%20kitchen%20with%20fresh%20ingredients%20on%20wooden%20countertop%2C%20herbs%20in%20pots%2C%20cooking%20utensils%2C%20warm%20morning%20light%2C%20inviting%20culinary%20space%2C%20food%20blog%20photography%20style%2C%20rustic%20and%20modern&width=400&height=300&seq=index-02&orientation=landscape',
  },
  {
    title: '健康养生',
    description: '饮食调理、运动健身、季节养生，守护全家健康',
    count: 287,
    icon: 'ri-heart-pulse-line',
    image: 'https://readdy.ai/api/search-image?query=Peaceful%20morning%20yoga%20space%20with%20mat%20and%20meditation%20cushions%2C%20sunlight%20through%20sheer%20curtains%2C%20green%20plants%2C%20calm%20and%20serene%20atmosphere%2C%20wellness%20lifestyle%20photography%2C%20natural%20and%20healthy%20living&width=400&height=300&seq=index-03&orientation=landscape',
  },
  {
    title: '旅行出游',
    description: '目的地攻略、旅行装备、出行贴士，世界那么大去看看',
    count: 198,
    icon: 'ri-flight-takeoff-line',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20mountain%20landscape%20view%20from%20wooden%20cabin%20deck%2C%20warm%20sunset%20colors%20in%20sky%2C%20comfortable%20outdoor%20chair%20with%20blanket%2C%20peaceful%20nature%20retreat%2C%20travel%20magazine%20photography%2C%20breathtaking%20and%20calming&width=400&height=300&seq=index-04&orientation=landscape',
  },
  {
    title: '省钱攻略',
    description: '消费避坑、理财入门、优惠汇总，聪明花钱快乐生活',
    count: 173,
    icon: 'ri-money-cny-circle-line',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20desk%20with%20notebook%2C%20calculator%2C%20and%20coffee%2C%20warm%20desk%20lamp%20light%2C%20organized%20personal%20finance%20setup%2C%20clean%20modern%20aesthetic%2C%20lifestyle%20blog%20photography%2C%20calm%20and%20focused&width=400&height=300&seq=index-05&orientation=landscape',
  },
  {
    title: '亲子育儿',
    description: '育儿经验、亲子活动、教育心得，陪伴孩子快乐成长',
    count: 241,
    icon: 'ri-parent-line',
    image: 'https://readdy.ai/api/search-image?query=Warm%20family%20living%20room%20with%20children%20books%20and%20toys%20neatly%20organized%2C%20soft%20rug%20on%20wooden%20floor%2C%20sunlight%20streaming%20in%2C%20cozy%20and%20loving%20home%20atmosphere%2C%20parenting%20lifestyle%20photography%2C%20peaceful%20and%20joyful&width=400&height=300&seq=index-06&orientation=landscape',
  },
  {
    title: '美容护肤',
    description: '护肤知识、美妆技巧、好物测评，由内而外的美好',
    count: 156,
    icon: 'ri-magic-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20vanity%20table%20with%20beauty%20products%20and%20fresh%20flowers%2C%20soft%20natural%20morning%20light%2C%20minimalist%20and%20clean%20aesthetic%2C%20self%20care%20and%20beauty%20routine%2C%20lifestyle%20blog%20photography%2C%20feminine%20and%20sophisticated&width=400&height=300&seq=index-07&orientation=landscape',
  },
];

export const mediaItems = [
  {
    title: '5 分钟学会日式便当摆盘，上班带饭也能仪式感满满',
    duration: '05:28',
    views: '8.2万',
    tag: '美食烹饪',
    image: 'https://readdy.ai/api/search-image?query=Beautifully%20arranged%20Japanese%20bento%20box%20on%20wooden%20table%2C%20colorful%20ingredients%20artistically%20presented%2C%20chopsticks%20beside%2C%20warm%20natural%20lighting%2C%20food%20photography%20style%2C%20clean%20and%20appetizing%20composition&width=600&height=340&seq=media-01&orientation=landscape',
  },
  {
    title: '收纳师上门改造：60 平米小户型实现三分离空间',
    duration: '12:15',
    views: '15.6万',
    tag: '居家妙招',
    image: 'https://readdy.ai/api/search-image?query=Well%20organized%20small%20apartment%20interior%20with%20smart%20storage%20solutions%2C%20foldable%20furniture%2C%20bright%20natural%20light%2C%20clean%20minimalist%20design%2C%20cozy%20living%20space%2C%20interior%20design%20photography%2C%20functional%20and%20beautiful&width=600&height=340&seq=media-02&orientation=landscape',
  },
  {
    title: '三伏天养生动作跟练版：每天 10 分钟疏通经络',
    duration: '10:42',
    views: '11.3万',
    tag: '健康养生',
    image: 'https://readdy.ai/api/search-image?query=Bright%20airy%20room%20with%20exercise%20mat%20on%20floor%2C%20morning%20sunlight%2C%20green%20plants%2C%20peaceful%20home%20gym%20setting%2C%20wellness%20and%20fitness%20lifestyle%2C%20warm%20and%20energetic%20atmosphere&width=600&height=340&seq=media-03&orientation=landscape',
  },
  {
    title: '百元改造出租屋阳台：从杂物间到秘密花园',
    duration: '08:50',
    views: '9.7万',
    tag: '居家改造',
    image: 'https://readdy.ai/api/search-image?query=Small%20balcony%20transformed%20into%20cozy%20garden%20with%20potted%20plants%2C%20string%20lights%2C%20small%20wooden%20table%20and%20chair%2C%20warm%20evening%20atmosphere%2C%20urban%20oasis%2C%20lifestyle%20photography%2C%20charming%20and%20peaceful&width=600&height=340&seq=media-04&orientation=landscape',
  },
  {
    title: '厨房新手入门：10 种基础刀工一次学会',
    duration: '07:35',
    views: '6.8万',
    tag: '美食烹饪',
    image: 'https://readdy.ai/api/search-image?query=Professional%20chef%20knife%20and%20fresh%20vegetables%20on%20wooden%20cutting%20board%2C%20kitchen%20scene%20with%20warm%20lighting%2C%20cooking%20preparation%2C%20clean%20and%20organized%20workspace%2C%20culinary%20photography%20style&width=600&height=340&seq=media-05&orientation=landscape',
  },
];

export const footerLinks = {
  sections: [
    {
      title: '内容板块',
      links: [
        { name: '居家妙招', href: '#index' },
        { name: '美食烹饪', href: '#index' },
        { name: '健康养生', href: '#index' },
        { name: '旅行出游', href: '#index' },
        { name: '省钱攻略', href: '#index' },
        { name: '亲子育儿', href: '#index' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { name: '平台介绍', href: '#about' },
        { name: '联系我们', href: '#contact' },
        { name: '投稿指南', href: '#contact' },
        { name: '常见问题', href: '#faq' },
      ],
    },
    {
      title: '关注我们',
      links: [
        { name: '微信公众号', href: '#contact' },
        { name: '微博', href: '#contact' },
        { name: '小红书', href: '#contact' },
        { name: '抖音', href: '#contact' },
      ],
    },
  ],
  partners: {
    title: '合作伙伴',
    description: '感谢每一位与今日看料携手同行的合作伙伴。我们保持开放态度，欢迎更多优质品牌与平台加入合作。',
  },
};